import React from "react"
import {
    componentStyles,
    ConditionalRenderContainer,
} from "@mallardbay/lib-react-components"

import type { ListingFieldsFragment } from "~graphql/generated/graphql"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import CheckoutTitle from "~components/pages/listing/checkout/checkout-title"
import COPY from "~config/copy-constants"
import CheckoutFlowBreadcrumbs from "~components/pages/listing/checkout/checkout-flow/checkout-flow-breadcrumbs"
import Box from "~components/shared/todo-lib-react-components/box"
import BackButton from "~components/shared/back-button"

export default function CheckoutFlowHeader() {
    const styles = useStyles()
    const { listing, handleOnBackClick, isWidget } = useCheckoutFlow()

    // For typescript.
    if (!listing) return null

    const title = getTitle(listing)

    return (
        <Box style={styles.root}>
            <ConditionalRenderContainer shouldRender={!isWidget}>
                <BackButton onBackClick={handleOnBackClick} />
                <CheckoutTitle title={title} />
            </ConditionalRenderContainer>
            <CheckoutFlowBreadcrumbs shouldHideListingLink={isWidget} />
        </Box>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            marginBottom: "40px",
        },
    })
}

function getTitle(listing: ListingFieldsFragment) {
    return `${COPY.BOOK_YOUR_TRIP_WITH} ${listing.outfitter.name}`
}
